function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 127.994h512v42.663H0zm0 85.337h512v42.663H0zm0 85.326h512v42.663H0zm0 85.337h512v42.663H0z",
  fill: "#d80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h256v183.797H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M140.919 219.429c-23.308 0-42.202-18.895-42.202-42.202s18.895-42.202 42.202-42.202a42.024 42.024 0 0120.075 5.072c-9.365-9.158-22.173-14.811-36.307-14.811-28.686 0-51.941 23.255-51.941 51.941s23.256 51.941 51.941 51.941c14.133 0 26.942-5.653 36.307-14.811a42.021 42.021 0 01-20.075 5.072z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.811 147.545l7.493 15.668 16.92-3.91-7.577 15.626 13.608 10.792-16.943 3.819.048 17.367-13.549-10.866-13.549 10.866.047-17.367-16.943-3.819 13.608-10.792-7.579-15.626 16.922 3.91z"
}));

const SvgMalaysia = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMalaysia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/malaysia.d4e6b369.svg";
export { ForwardRef as ReactComponent };